// Политика Конфиденциальности
export const WEB_POLICY_LINK = `https://cdn.iport.ru/iport/pdf/Politika_konfidecialnosti_PT_sajt_IPort.pdf`
// Согласием на обработку персональных данных
export const WEB_CONSEST_LINK = `https://cdn.iport.ru/iport/pdf/soglasie_IPort_.pdf`
// Оферта или порядок продажи
export const WEB_OFFER_LINK = `https://cdn.iport.ru/iport/pdf/oferta-footer.pdf `
// Оферта iport plus
export const WEB_OFFER_PLUS_LINK = 'https://cdn.iport.ru/iport/pdf/oferta_Iport+_2.0.pdf'
// Политика Конфиденциальности СЦ
export const WEB_POLICY_LINK_SC = 'https://cdn.iport.ru/iport/pdf/politika_konfidencialnosti_TS_IPort.pdf'
// Согласием на обработку персональных данных СЦ
export const WEB_CONSEST_LINK_SC = 'https://cdn.iport.ru/iport/pdf/soglasie_TS_IPort.pdf'
// Оферта СЦ
export const WEB_OFFER_LINK_SC_NEW = 'https://cdn.iport.ru/iport/pdf/SC_iPort_Agreement.pdf'
// Оферта или порядок продажи СЦ
export const WEB_OFFER_LINK_SC = 'https://cdn.iport.ru/iport/pdf/oferta-iPort-Service.pdf'
// Оферта Бонусная программа NBclub
export const WEB_OFFER_BONUSES_LINK = 'https://cdn.iport.ru/iport/pdf/oferta_nbclub_new.pdf'
// Оферта ПО UniSafe
export const WEB_OFFER_UNISAFE = `https://cdn.iport.ru/iport/pdf/oferta_Unisafe.pdf`
